import "./MicrosoftSignin.scss";

import { Alert, Flex, Text } from "@fluentui/react-northstar";
import React from "react";

import MicrosoftSignInLogo from "../assets/microsoft-sign-in.svg";
import { localStorageAvailable } from "../utils/teamsHelpers";
import SignInCard from "./sign-in-card.png";

type Props = {
  appTitle?: string;
  hideCards?: boolean;
  onSignIn: () => void;
};

export const MicrosoftSignIn: React.FC<Props> = ({ appTitle, onSignIn, hideCards }) => {
  if (!localStorageAvailable()) {
    return <Alert content={"3rd party cookies are required for this application."} danger />;
  }

  return (
    <Flex column hAlign="center" gap="gap.medium" className="microsoftsignin">
      {appTitle && (
        <Text
          size="large"
          weight="bold"
          as="div"
          align="center"
          content={`Sign into your ${appTitle} account`}
        />
      )}

      {!hideCards && (
        <img src={SignInCard} alt="Login" className="microsoftsignin__imagecard"></img>
      )}

      <button
        className="microsoftsignin__loginbutton"
        onClick={e => {
          e.preventDefault();
          onSignIn();
        }}
      >
        <img src={MicrosoftSignInLogo} alt="Sign in with Microsoft" />
      </button>
    </Flex>
  );
};
